export default __webpack_public_path__ + "static/media/rafazicati.79e0f237.jpg";